import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import enTranslations from './locales/en.json'
import arTranslations from './locales/ar.json'

// Get user-specific localStorage key
const getUserLanguageKey = (userId) => {
  return userId ? `i18nextLng_${userId}` : 'i18nextLng'
}

// Check for saved language in localStorage on initialization
const getInitialLanguage = () => {
  // First, try to get userId from localStorage (set when user logs in)
  const currentUserId = localStorage.getItem('currentUserId')
  if (currentUserId) {
    const userLangKey = getUserLanguageKey(currentUserId)
    const savedLang = localStorage.getItem(userLangKey)
    if (savedLang && (savedLang === 'en' || savedLang === 'ar')) {
      return savedLang
    }
  }
  
  // Fallback to default localStorage key
  const defaultLang = localStorage.getItem('i18nextLng')
  if (defaultLang && (defaultLang === 'en' || defaultLang === 'ar')) {
    return defaultLang
  }
  
  // Final fallback
  return 'en'
}

// Language detector configuration - user-specific
const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'userLocalStorage',
  lookup(options) {
    // Try to get userId from Redux store or localStorage
    const userId = options.userId || localStorage.getItem('currentUserId')
    const key = getUserLanguageKey(userId)
    const stored = localStorage.getItem(key)
    return stored || null // Return null to let other detectors handle it
  },
  cacheUserLanguage(lng, options) {
    const userId = options.userId || localStorage.getItem('currentUserId')
    if (userId) {
      const key = getUserLanguageKey(userId)
      localStorage.setItem(key, lng)
    } else {
      // Also save to default key as fallback
      localStorage.setItem('i18nextLng', lng)
    }
  },
})

// Get initial language
const initialLanguage = getInitialLanguage()

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      ar: {
        translation: arTranslations,
      },
    },
    lng: initialLanguage, // Set initial language explicitly
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['userLocalStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    react: {
      useSuspense: false,
    },
  })

// Set RTL direction based on language
i18n.on('languageChanged', (lng) => {
  const html = document.documentElement
  html.setAttribute('lang', lng)
  html.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr')
  
  // Update body class for RTL styling
  document.body.classList.toggle('rtl', lng === 'ar')
  document.body.classList.toggle('ltr', lng !== 'ar')
})

// Initialize direction on load
const currentLang = i18n.language || 'en'
const html = document.documentElement
html.setAttribute('lang', currentLang)
html.setAttribute('dir', currentLang === 'ar' ? 'rtl' : 'ltr')
document.body.classList.toggle('rtl', currentLang === 'ar')
document.body.classList.toggle('ltr', currentLang !== 'ar')

export default i18n

